/** API 默认跟随网页部署路径；显式配置可用于独立 API 域名。 */
export function resolveApiBase(deploymentBase: string, configuredBase?: string): string {
  const base = configuredBase?.trim() || `${deploymentBase.replace(/\/+$/, '')}/api`;
  return base.replace(/\/+$/, '');
}
